import axios from 'axios';
import {
  roadcqcOldAppUrl,
  roadcqcOldBackendUrl,
  roadcqcBackendUrl
} from '@/utils/qcGatewayBase'

/**
 * 网关对照（与 businesssystem qcApiRouteMap 一致）
 * - roadcqcOldAppUrl      → /sit-api/roadcqcold-app      拌合/预警/运输/萤石云等
 * - roadcqcOldBackendUrl  → /sit-api/roadcqcold-backend  工程/标段/工区(e/r)
 * - roadcqcBackendUrl     → /sit-api/roadcqc-backend      视频监控配置、jk 设备列表
 * roadcqcHw（/sit-api/hw-cons）仅 businesssystem 新大屏地图用 /hwdata/road_line/withId，本仓库暂无对应接口
 */
// axios.create({
//   headers:{
//     "Content-Type":'application/json;charset=UTF-8'
//   }
// })
// axios.defaults.timeout = 20000;
axios.defaults.withCredentials = true; // 允许携带cookie
// withCredentials:true,
// const Channel_url = '/ch'
// const P_url = 'http://59.110.143.238:21104'
const Channel_url = 'https://jk-xs.yemast.com:8007'
const api = {
  login: '/sso/login', //登录
  listEngineer: '/e/r/base/engineering/listEngineer', //获取工程（迁移至 roadcqcOldBackend）
  listWorkArea: '/e/r/base/workArea/listWorkAreas', //标段反查工区（迁移至 roadcqcOldBackend）
  listWorkAreaE: '/global/listWorkArea', //工程查询工区
  listSection: '/e/r/base/section/listSection', //获取标段（迁移至 roadcqcOldBackend）
  sectionDetail: '/global/section/detail', //获取标段信息(设计单位)
  weather: '/common/weather/getAreaWeather', //获取天气
  envData: '/common/weather/getEnvData', //获取环境检测

  // 后场sw
  // mixplantsw:'/sw/mixplant/realTimeMixplant', //获取拌合楼
  // keyLabelsw:'/sw/mixplant/keyLabel', //获取当前实时数据
  // realTimeOutputsw:'/sw/mixplant/realTimeOutput', //获取当日实时数据
  // 后场lq
  mixplant: '/mixplant/realTimeMixplant', //获取拌合楼
  keyLabel: '/mixplant/keyLabel', //获取当前实时数据
  cement: '/mixplant/byTime/cement', //获取当前实时数据
  realTimeOutput: '/mixplant/realTimeOutput', //获取当日实时数据

  // 进度分析
  progressInfo: '/project/info', //获取总工程与标段进度

  // 预警数
  warningList: '/warning/hisWarningListSummary', //获取预警数
  warningPageList: '/warning/currentWarningList', //预警列表分页
  warningDetail: '/warning/detail', //预警详情
  warningPeriodSummary: '/warning/periodSummary', //预警汇总统计

  // 运输
  QuantityOfTrucks: '/transport/realTimeQuantityOfTrucks', //在途车辆
  summarizingInfo: '/transport/summarizingInfo', //运输汇总（对齐 businesssystem 命名）
  todaySummary: '/e/r/transport/todaySummary',
  transportListDetail: '/e/r/transport/analyze/listDetail', //车次列表详情

  // 前场
  frontWork: '/complex/frontWork', //获取前场数据
  lastPaveTimeByWorkArea: '/lq/pave/getLastPaveTimeByWorkArea', //作业面最后摊铺机开机时间
  tempWind: '/transport/realTimeEnvironmental', //获取温度风速
  //视频
  getChannel: Channel_url + '/init/getChannelByWorkareaId', //获取视频地址
  getImgUrl: Channel_url + '/api/v1/getchannels', //获取视频图片
  touchchannelstream: Channel_url + '/api/v1/touchchannelstream', //保活接口
  // getChannel:'http://192.168.3.50:8083/init/getChannelByWorkareaId',//获取视频地址
  // getImgUrl:'http://119.45.190.236:10800/api/v1/getchannels',//获取视频图片
  // touchchannelstream:'http://119.45.190.236:10800/api/v1/touchchannelstream'//保活接口

  // 新视频监控接口（roadcqc-backend，与 businesssystem monitoring 一致；非 unisystem / hw-cons）
  getNewChannel: '/e/r/jk/cameraDevice/dataList',
  getNewImgUrl: 'https://open.ys7.com/api/lapp/v2/live/address/get',
  disableLiveAddress: 'https://open.ys7.com/api/lapp/v2/live/address/disable',
  captureImage: 'https://open.ys7.com/api/lapp/device/capture',

  // 视频监控配置分页列表(与PC端一致)
  videoConfigPageList: '/e/r/ys/video/config/pageList',
  videoConfigGetList: '/e/r/ys/video/config/getList',

  // 萤石云接口
  appKey: 'ys7/getYs7Token',
  getrealChannel: '/ys7/getAllAtWorkAreaId',
  moveCamera: 'ys7/ptzControl'
}
// 获取当前时间
export function getCurrentTime() {
  const val = new Date();
  const y = val.getFullYear();
  const m = (val.getMonth() + 1).toString().padStart(2, "0");
  const d = val
    .getDate()
    .toString()
    .padStart(2, "0");
  const h = val
    .getHours()
    .toString()
    .padStart(2, "0");
  const mi = val
    .getMinutes()
    .toString()
    .padStart(2, "0");
  const s = val
    .getSeconds()
    .toString()
    .padStart(2, "0");
  return `${y}-${m}-${d} ${h}:${mi}:${s}`;
}
// 获取监控列表
export function getRealChannel(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.getrealChannel),
    method: 'get',
    params: parameter
  })
}
// 获取appKey
export function getAppKey(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.appKey),
    method: 'get',
    params: parameter
  })
}
// 移动镜头
export function moveCameraR(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.moveCamera),
    method: 'get',
    params: parameter
  })
}
//登录
export function loginSystem(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.login),
    method: 'get',
    params: parameter,
    withCredentials: true
  })
}
//获取工程
export function getListEngineer(parameter) {
  return axios({
    url: roadcqcOldBackendUrl(api.listEngineer),
    method: 'get',
    params: parameter
  })
}
//获取标段
export function getListSection(parameter) {
  return axios({
    url: roadcqcOldBackendUrl(api.listSection),
    method: 'get',
    params: parameter
  })
}
// 获取工区
export function getListWorkArea(parameter) {
  return axios({
    url: roadcqcOldBackendUrl(api.listWorkArea),
    method: 'get',
    params: parameter
  })
}
// 获取工区
export function getListWorkAreaE(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.listWorkAreaE),
    method: 'get',
    params: parameter
  })
}
//获取标段信息
export function getSectionDetail(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.sectionDetail),
    method: 'get',
    params: parameter
  })
}
//获取天气
export function getWeather(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.weather),
    method: 'get',
    params: parameter
  })
}
//获取环境监测数据
export function getInitScreenData(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.envData),
    method: 'get',
    params: parameter
  })
}
//获取在途车辆
export function getQuantityOfTrucks(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.QuantityOfTrucks),
    method: 'get',
    params: parameter
  })
}
//获取总车次
export function getSummarizingInfo(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.summarizingInfo),
    method: 'get',
    params: parameter
  })
}
//获取车次列表详情
export function getTransportTodaySummary(parameter) {
  return axios({
    url: roadcqcOldBackendUrl(api.todaySummary),
    method: 'get',
    params: parameter
  })
}
//获取车次列表详情
export function getTransportListDetail(parameter) {
  return axios({
    url: roadcqcOldBackendUrl(api.transportListDetail),
    method: 'get',
    params: parameter
  })
}
// //获取sw拌合楼
// export function getMixplantsw(parameter) {
//   return axios({
//     url: P_url +api.mixplantsw,
//     method: 'get',
//     params: parameter
//   })
// }
//获取sw当前实时数据
// export function getKeyLabelsw (parameter) {
//   return axios({
//     url: P_url +api.keyLabelsw,
//     method: 'get',
//     params: parameter
//   })
// }
// //获取sw当日实时数据
// export function getRealTimeOutputsw (parameter) {
//   return axios({
//     url: P_url +api.realTimeOutputsw,
//     method: 'get',
//     params: parameter
//   })
// }
//获取拌合楼(lp/sw)
export function getMixplant(type, parameter) {
  return axios({
    url: roadcqcOldAppUrl('/' + type + api.mixplant),
    method: 'get',
    params: parameter
  })
}
//获取当前实时数据
export function getKeyLabel(type, parameter) {
  return axios({
    url: roadcqcOldAppUrl('/' + type + api.keyLabel),
    method: 'get',
    params: parameter
  })
}

//获取当前实时数据
export function getCement(type, parameter) {
  return axios({
    url: roadcqcOldAppUrl('/' + type + api.cement),
    method: 'get',
    params: parameter
  })
}
//获取当日实时数据
export function getRealTimeOutput(type, parameter) {
  return axios({
    url: roadcqcOldAppUrl('/' + type + api.realTimeOutput),
    method: 'get',
    params: parameter
  })
}
//获取预警数
export function getProgressInfo(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.progressInfo),
    method: 'get',
    params: parameter
  })
}
//获取预警数
export function getWarningList(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.warningList),
    method: 'get',
    params: parameter
  })
}
//获取预警列表分页
export function getWarningPageList(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.warningPageList),
    method: 'get',
    params: parameter
  })
}
//获取预警汇总统计
export function getWarningPeriodSummary(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.warningPeriodSummary),
    method: 'get',
    params: parameter
  })
}
//获取预警详情
export function getWarningDetail(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.warningDetail),
    method: 'get',
    params: parameter
  })
}
//获取前场数据
export function getFrontWork(type, parameter) {
  return axios({
    url: roadcqcOldAppUrl('/' + type + api.frontWork),
    method: 'get',
    params: parameter
  })
}
//获取作业面最后摊铺机开机时间
export function getLastPaveTimeByWorkArea(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.lastPaveTimeByWorkArea),
    method: 'get',
    params: parameter
  })
}
//获取前场温度风速
export function getTempWind(parameter) {
  return axios({
    url: roadcqcOldAppUrl(api.tempWind),
    method: 'get',
    params: parameter
  })
}

//获取视频地址
export function getChannels(parameter) {
  return axios({
    url: api.getChannel,
    method: 'get',
    params: parameter
  })
}

//获取视频图片
export function getImgUrl(parameter) {
  return axios({
    url: api.getImgUrl,
    method: 'get',
    params: parameter
  })
}
//获取视频地址
export function getNewChannels(parameter) {
  return axios({
    url: roadcqcBackendUrl(api.getNewChannel),
    method: 'get',
    params: parameter
  })
}

//获取视频流地址（失败静默，不向外抛错、不触发报错提示）
export function getNewImgUrl(parameter) {
  return axios({
    url: api.getNewImgUrl,
    method: 'post',
    params: parameter,
    withCredentials: false,
    validateStatus: () => true
  }).then(res => res).catch(() => ({
    data: {}
  }))
}


// 萤石云截屏（失败静默，不向外抛错、不触发报错提示）
export function captureImage(parameter) {
  return axios({
    url: api.captureImage,
    method: 'post',
    params: parameter,
    withCredentials: false,
    validateStatus: () => true
  }).then(res => res).catch(() => ({
    data: {}
  }))
}

//保活接口
export function touchchannelstream(parameter) {
  return axios({
    url: api.touchchannelstream,
    method: 'get',
    params: parameter
  })
}

// 获取视频监控配置分页列表(新接口 - 与PC端一致)
export function getVideoConfigPageList(parameter) {
  return axios({
    url: roadcqcBackendUrl(api.videoConfigPageList),
    method: 'get',
    params: parameter
  })
}

// 获取视频监控配置分页列表(新接口 - 与PC端一致)
export function getVideoConfigGetList(parameter) {
  return axios({
    url: roadcqcBackendUrl(api.videoConfigGetList),
    method: 'get',
    params: parameter
  })
}

// 销毁直播地址
export function disableLiveAddress(parameter) {
  return axios({
    url: api.disableLiveAddress,
    method: 'post',
    params: parameter
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js